export default __webpack_public_path__ + "static/media/Dialog6.e3753f82.svg";